import { useParams } from 'react-router-dom';

import PlanningScreen from '../../features/plans/layouts/planning';
import PlanScreen from '../../features/plans/layouts/plan';
import CreatePlanForm from '../../features/plans/forms/create';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/plans               → la sección, entre proyectos y con su filtro
//   /admin/plans/new           → the create form, with ?project=N
//   /admin/plans/:id           → the plan, opened on its approved version
//   /admin/plans/:id/v/:number → that exact version
//
// `:number` IS THE VERSION NUMBER, not a row id. The segment is spelled `/v/`
// so the URL reads the way people speak — «v2 del plan 3» — and so nobody is
// tempted to paste a database id into it.

export default function PlansPage({ mode }) {
    const { id, number } = useParams();

    if (mode === 'create' || id === 'new') return <CreatePlanForm />;
    if (!id) return <PlanningScreen />;
    return <PlanScreen planId={id} versionNumber={number} />;
}
